export default class addSuppression {
    constructor() {
        return {
            template: require('../../../../views/subscriber/modal/add-suppression.html'),
            replace: true,
            restrict: 'E',
            scope: {
                columns: '='
            },
            controller: AddSuppressionCtrl,
            controllerAs: 'layover'
        }
    }
};

class AddSuppressionCtrl {
    constructor($scope) {
        this._scope = $scope;

        this._scope.$on('import:add:suppression', () => {
            this.show = ! this.show;

            this.resetSuppressions();

            angular.forEach(this._scope.columns, (column) => {
                if (column.field == 'rule_suppress') {
                    this.parseImportSuppressed(column.value);
                }
            });
        });

        this._scope.$on('subscriber:show:suppression', (event, subscriber) => {
            this.resetSuppressions();

            this.show = ! this.show;
            this.subscriber = subscriber;

            if (this.subscriber.suppressions) {
                this.parseSubscriberSuppresed(this.subscriber.suppressions.data);
            }
        });

        $(document).keyup((e) => {
            if (e.keyCode == 27) {
                this.show = false;
                this._scope.$apply(); // Close modal on escape.
            }
        });
    }

    resetSuppressions() {
        this.subscriber = null;
        this.suppression = {
            campaign: {
                email: false,
                text_message: false
            },
            transactional: {
                email: false,
                text_message: false
            }
        }
    }

    parseSubscriberSuppresed(suppressions) {
        angular.forEach(suppressions, (suppressed) => {
            angular.forEach(this.suppression, (value) => {
                const dispatcherType = suppressed.dispatcherType.data.name;
                const messageType = suppressed.messageType.data.name;

                if (dispatcherType in value && messageType in value[dispatcherType]) {
                    this.suppression[dispatcherType][messageType] = true;
                }
            });
        });

        this.alreadySuppresed = angular.copy(this.suppression);
    }

    parseImportSuppressed(suppressed) {
        angular.forEach(suppressed.split('|'), (dispatcher) => {
            let messageTypes = dispatcher.split(':');
            dispatcher = messageTypes[0];
            delete messageTypes[0];

            angular.forEach(messageTypes, (type) => {
                this.suppression[dispatcher][type] = true;
            });
        });
    };

    formatImportSuppressOn() {
        let suppressFor = '';
        let campaignSuppressions = [];
        let transactionSuppressions = [];

        angular.forEach(this.suppression.campaign, (suppressMessageType, messageType) => {
            if (suppressMessageType && messageType !== 'undefined') {
                campaignSuppressions.push(messageType);
            }
        });

        angular.forEach(this.suppression.transactional, (suppressMessageType, messageType) => {
            if (suppressMessageType && messageType !== 'undefined') {
                transactionSuppressions.push(messageType);
            }
        });

        suppressFor += campaignSuppressions.length ? 'campaign:' + campaignSuppressions.join(':') : '';
        suppressFor += transactionSuppressions.length ? '|transaction:' + transactionSuppressions.join(':') : '';

        if (suppressFor[0] == '|') {
            suppressFor = suppressFor.replace('|', '');
        }

        return suppressFor;
    };

    hasCurrentImportSuppressions() {
        let currentSuppressions = false;

        angular.forEach(this._scope.columns, (column) => {
            if (column.field == 'rule_suppress') {
                currentSuppressions = true;
            }
        });

        return currentSuppressions;
    };

    toggleShow() {
        this.show = ! this.show;
    };

    save() {
        if (this._scope.columns) {
            this.saveImportSuppressions();
        } else {
            this.saveSubscriberSuppressions();
        }

        this.toggleShow();
    };

    saveImportSuppressions() {
        let suppressOn = this.formatImportSuppressOn();
        let currentSuppressions = this.hasCurrentImportSuppressions();

        if (! currentSuppressions) {
            this._scope.columns.push({
                field: 'rule_suppress',
                value: suppressOn
            });
        } else {
            angular.forEach(this._scope.columns, (column) => {
                if (column.field == 'rule_suppress') {
                    column.value = suppressOn;
                }
            });
        }
    }

    saveSubscriberSuppressions() {
        angular.forEach(this.suppression, (dispatcherValue, dispatcherKey) => {
            this.suppression[dispatcherKey] = _.compact(_.map(dispatcherValue, (value, key) => {
                if (value) {
                    return key;
                }
            }));
        });

        this._scope.$emit('subscriber:add:suppression', {
            subscriberId: this.subscriber.id,
            suppression: this.suppression
        });
    }
}